export const APPOINTMENT_STATUS_SORT_ORDER = {
  pending: 0,
  confirmed: 1,
  in_progress: 2,
  done: 3,
  missed: 4,
  cancelled: 5
};

// ARRIVED was removed from the lifecycle: a confirmed booking moves straight to
// in_progress (e.g. when the arrival OTP is verified).
export const BOOKING_STATUS_TRANSITIONS = {
  pending: ['confirmed', 'cancelled', 'missed'],
  confirmed: ['in_progress', 'cancelled', 'missed'],
  in_progress: ['done', 'cancelled'],
  done: [],
  cancelled: [],
  missed: []
};

export const BOOKING_STATUS_BACKEND_VALUES = {
  pending: 'PENDING',
  confirmed: 'CONFIRMED',
  in_progress: 'IN_PROGRESS',
  done: 'COMPLETED',
  cancelled: 'CANCELLED',
  missed: 'NO_SHOW'
};

export const normalizeBookingStatus = (value) => {
  const status = String(value || '').toLowerCase();
  if (status.includes('pend')) return 'pending';
  if (status.includes('progress')) return 'in_progress';
  // Legacy ARRIVED rows are surfaced as In Progress (the ARRIVED step is gone).
  if (status.includes('arriv')) return 'in_progress';
  if (status.includes('done') || status.includes('complete') || status.includes('served')) return 'done';
  if (status.includes('miss') || (status.includes('no') && status.includes('show'))) return 'missed';
  if (status.includes('cancel')) return 'cancelled';
  return 'confirmed';
};

export const toBackendBookingStatus = (value) => {
  const normalized = normalizeBookingStatus(value);
  return BOOKING_STATUS_BACKEND_VALUES[normalized] || String(value || '').toUpperCase();
};

export const bookingStatusLabel = (value) => {
  const normalized = normalizeBookingStatus(value);
  if (normalized === 'pending') return 'Pending';
  if (normalized === 'in_progress') return 'In Progress';
  if (normalized === 'missed') return 'Missed';
  if (normalized === 'done') return 'Done';
  if (normalized === 'cancelled') return 'Cancelled';
  return 'Confirmed';
};
